import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import FuseTheme from '../global/theme';
import IconButton from 'material-ui/IconButton';
import ContentView from 'material-ui/svg-icons/image/remove-red-eye';

const styles = {
    icon: {
        display: 'inline-block',
        width: 40,
        height: 26,
        color: '#262360',
        padding: '0 0 0 10px',
        verticalAlign: 'top',
        cursor: 'pointer',
        overflow: 'inherit'
    },
};

const ViewButtonByCustomRoute = ({customPath, basePath = ''}) => (
    <IconButton
        containerElement={<Link to={`${basePath}/${customPath}`}/>}
        style={styles.icon}
    >
        <ContentView color={FuseTheme.palette.primary1Color}/>
    </IconButton>
);

ViewButtonByCustomRoute.propTypes = {
    basePath: PropTypes.string,
    customKey: PropTypes.string,
    record: PropTypes.object,
};

ViewButtonByCustomRoute.defaultProps = {
    style: {padding: 0},
};

export default ViewButtonByCustomRoute;



// WEBPACK FOOTER //
// ./src/Fuse/buttons/ViewButtonByCustomRoute.js